import { render, staticRenderFns } from "./data-lake.vue?vue&type=template&id=0ef223e9&scoped=true"
import script from "./data-lake.ts?vue&type=script&lang=ts&external"
export * from "./data-lake.ts?vue&type=script&lang=ts&external"
import style0 from "./data-lake.scss?vue&type=style&index=0&id=0ef223e9&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef223e9",
  null
  
)

export default component.exports